export const ACRYL_STANDIZER_OPTS = {
  DEFAULT_OFFSET_MM: 3,
  RESIZE_KERNEL: 'nearest',
  SMOOTH_OFFSET_ADDER: 60,
  STROKE_STYLE: {
    fillColor: 'transparent',
    strokeColor: '#ff00b4',
    strokeWidth: 1,
    strokeDashArray: undefined,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
  STAND_DIMENSION_MM: {
    ground: {
      height: 0,
      width: 20,
      round: 0.25,
    },
    notch: {
      height: 3.4,
      width: 15,
      round: 0.25,
    },
  },
  ALPHA_THRESHOLD: 25,
  BLUR_SIGMA: 15,
};

export const MAPLE_CHARACTER_IMAGE_PREPROCESS = {
  // Crop 하지 않기로 open 스펙 변경됨
  crop_position: { x: 0, y: 0, w: 300, h: 188 },
  scale_factor: 10.8267,
  alpha_threshold: 0,
  blur_sigma: 19,
  smooth_offset_adder: 100,
  offset_distance_mm: 2.8,
  stand_dimension_mm: {
    ground: {
      height: 0,
      width: 20,
      round: 0.25,
    },
    notch: {
      height: 3.2,
      width: 15,
      round: 0.25,
    },
  },
  stroke_style: {
    fillColor: 'transparent',
    strokeColor: '#ff00b4',
    strokeWidth: 1,
    strokeDashArray: undefined,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
  // simplify: {
  //   method: 'simplifyjs' as const,
  //   simplifyOptions: {
  //     tolerance: 20,
  //     highQuality: false,
  //   },
  // },
  curvify: {
    method: 'odiak' as const,
    curvifyOptions: {
      maxError: 10,
    },
  },
  concurrency: 1,
  to_dpi_300: true,
};

// export const NAME_TAG_OPTS = {
//   FONT_FAMILY: 'https://s3.marpple.co/font/maker/ko/morris__normal__normal.ttf',
//   FONT_COLOR: '#FFFFFF',
//   FONT_SIZE: 63,
//   PADDING: { x: 5, y: 5 },
//   MARGIN: { x: 5, y: 5 },
//   BACKGROUND_COLOR: '#333333',
//   EDGE_REMOVAL_SIZE: 5,
//   ROUND: 5,
//   STROKE_STYLE: {
//     fillColor: 'transparent',
//     strokeColor: '#ff00b4',
//     strokeWidth: 1,
//   },
// };

export const NAME_TAG_OPTS = {
  FONT_FAMILY: 'https://s3.marpple.co/font/maker/ko/morris__normal__normal.ttf',
  // FONT_FAMILY: 'https://s3.marpple.co/font/maker/ko/morris__normal__normal2.ttf',
  FONT_COLOR: '#FFFFFF',
  FONT_SIZE: 67,
  PADDING: { x: 21, y: 21 },
  MARGIN: { x: 32, y: 32 },
  BACKGROUND_COLOR: '#333333',
  EDGE_REMOVAL_SIZE: 5,
  ROUND: 32,
  STROKE_STYLE: {
    fillColor: 'transparent',
    strokeColor: '#ff00b4',
    strokeWidth: 1,
  },
};
